import store from '../../store/store'

import('./date_picker.css')

export default function DatePicker(opts={}){
    BaseConstructor.call(this)
    let {container, singleDatePicker} = opts
    let elements = {}
    let context = this
    let rangepicker

    this.generate = () =>{
        elements.container = this.createElement('div', 'date-picker-container')
        elements.input_container = this.createElement('div', 'date-picker-input-container')
        elements.input = this.createElement('input', 'date-picker-input')
        elements.icon_container = this.createElement('div', 'date-picker-icon-container', '<i class="far fa-calendar"></i>')
        elements.icon_container.title = 'AGORA'
        $(elements.container).append(elements.input_container)
        $(elements.input_container).append(elements.input,elements.icon_container)
        $(container).append(elements.container)


        rangepicker = $(elements.input).daterangepicker({
            singleDatePicker: singleDatePicker != undefined ? singleDatePicker : true,
            locale: {format: 'DD/MM/YYYY'},
            timePicker: false,
            showCustomRangeLabel:false,
            autoApply:true,
            maxDate: new Date()
        }, function(start, end, label){
            start = new Date(start.valueOf())
            end = singleDatePicker ==  undefined || singleDatePicker === true ? start : new Date(end.valueOf())
            context.trigger('date-picker-change', {start, end, label})
        });

        elements.input.value = 'AGORA'

        $(elements.icon_container).on('click', () =>{
            elements.input.value = 'AGORA'
            store.mainConfigStore.setPeriod('')
            // context.setStartDate(new Date(),new Date())
        })

    }

    this.setStartDate = (date) =>{
        rangepicker.data('daterangepicker').setStartDate(date);
    }

    this.setEndDate = (date) =>{
        rangepicker.data('daterangepicker').setEndDate(date);
    }

    this.setDate = (start, end) =>{
        this.setStartDate(start)
        this.setStartDate(end)
        this.trigger('date-picker-change', {start, end})
    }

    const validateDate = date =>{
        return true
    }
}

DatePicker.prototype = Object.create(BaseConstructor.prototype)